export default __webpack_public_path__ + "static/media/icon_wechat_pay.0ae479e6.png";